import {
  ChevronsUpDown,
  CircleUserRound,
  KeyRound,
  LogOut,
} from "lucide-react";

import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { User } from "@/api/SolarCloudApi";
import { cn } from "@/lib/utils";
import { Link, useNavigate } from "react-router";
import { useAuth } from "@/hooks/useAuth";
import { useUser } from "@/queries/user/useUser";
import { Button } from "./ui/Button";
import { useOrderUuid } from "@/stores/orderIdStore";
import { useNewOrder } from "@/queries/order/useNewOrder";

// export type User = {
//     lastLogin?: any;
//     addresses?: Array<UserAddress>;
//     updatedBy?: string;
//     updateVersion?: number;
//     joined?: any;
//     givenName?: string;
//     groups?: Array<string>;
//     uuid?: UUID;
//     userid?: string;
//     phoneNumbers?: Array<UserPhoneNumber>;
//     xeroId?: UUID;
//     updateAction?: Action;
//     emails?: Array<UserEmail>;
//     otherNames?: string;
//     organisationalRoles?: Array<OrganisationUser>;
//     organisations?: Array<Organisation>;
//     familyName?: string;
//     updated?: any;
//     status?: UserStatus;
// };

export function NavUserBuyPanels() {
  const navigate = useNavigate();
  const { data: user } = useUser();
  const orderUuid = useOrderUuid();
  const { data: order } = useNewOrder({ uuid: orderUuid! });

  const itemCount = order?.items?.reduce((sum, it) => sum + ((it.units ?? 0) / 100), 0) ?? 0;
  const displayItemCount = Math.round(itemCount);

  const { handleSignOut } = useAuth();

  // console.log("@@@@ user", user);

  return (
    <ul className="flex flex-col items-end gap-2 sm:flex-row sm:items-center sm:gap-3 min-w-0 overflow-hidden">
      <li className="order-2 sm:order-1">
        <Link to="/buypanels" className="flex items-center gap-2 text-lg text-white/90 hover:opacity-90">
          <span className="Cart-inner inline-flex items-center">
            <svg className={cn("icon icon--cart w-6 h-6 sm:w-7 sm:h-9", itemCount > 0 && "text-brand-orange-500")} width="30" height="36" viewBox="0 0 124 144" fill="currentColor" aria-hidden>
              <path d="M118.593 44.4305C118.434 41.0742 115.574 38.3573 112.236 38.3573H90.3006C88.3944 15.9824 76.632 0 62.0093 0C47.3866 0 35.6256 15.9824 33.718 38.3573H11.7849C8.44708 38.3573 5.58639 41.0743 5.42798 44.4305L0.0239157 137.128C-0.134716 138.886 0.501124 140.644 1.77277 141.922C3.04445 143.201 4.63335 144 6.38211 144H117.642C119.391 144 121.138 143.201 122.251 141.922C123.523 140.644 124 138.886 124 137.128L118.593 44.4305ZM62.0083 9.58967C71.0672 9.58967 79.0146 22.3756 80.7635 38.358H43.2518C45.0006 22.3756 52.948 9.58967 62.007 9.58967H62.0083ZM38.3266 67.1256C34.8302 67.1256 31.9698 64.2492 31.9698 60.7336C31.9698 57.2178 34.8303 54.3415 38.3266 54.3415C41.8229 54.3415 44.6835 57.2179 44.6835 60.7336C44.6848 64.2494 41.8229 67.1256 38.3266 67.1256ZM86.0074 67.1256C82.511 67.1256 79.6506 64.2492 79.6506 60.7336C79.6506 57.2178 82.5111 54.3415 86.0074 54.3415C89.5037 54.3415 92.3643 57.2179 92.3643 60.7336C92.3656 64.2494 89.5037 67.1256 86.0074 67.1256Z" />
            </svg>
            <div className="icon-cart-quantity ml-0.5 sm:ml-1">
              <span className="cart-quantity-container">
                <span className={cn("sqs-cart-quantity text-xs sm:text-sm", itemCount > 0 && "text-brand-orange-500 font-bold")}>{displayItemCount}</span>
              </span>
            </div>
          </span>
        </Link>
      </li>
      {user && (
        <li className="hidden sm:block">
          <Link
            className="text-xs sm:text-sm hover:underline tracking-wide"
            to="/dashboard"
          >
            Dashboard
          </Link>
        </li>
      )}
      {!user && (
        <li>
          <Button
            asChild
            variant="ghost"
            className="text-xs sm:text-sm tracking-wide text-white/80 border hover:text-brand-neutral-900 hover:bg-brand-orange-500"
          >
            <Link to="/login">Login</Link>
          </Button>
        </li>
      )}
      {user && (
        <li className="order-1 sm:order-4 pt-2 sm:pt-0">
          <Button
            onClick={() => {
              handleSignOut();
            }}
            className="text-xs sm:text-sm tracking-wide text-white/80 border hover:text-brand-neutral-900 hover:bg-brand-orange-500"
            variant="ghost"
          >
            <LogOut className="size-4" />
            <span className="sr-only">Logout</span>
            <span className="hidden sm:inline">Logout</span>
          </Button>
        </li>
      )}
    </ul>
  );
}
